import { formatDate } from 'views/Components/Shared/utils/formatDate';
import ChangesField from '../ChangesField';
import EmptyTable from 'views/Components/Shared/Components/EmptyTable';

export const slots = {
	noRowsOverlay: EmptyTable,
	noResultsOverlay: EmptyTable,
};

export const columns = [
	{
		field: 'sku',
		headerName: 'SKU',
		headerClassName: 'header border-bottom',
		minWidth: 70,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'modified_by',
		headerName: 'Modificado por',
		headerClassName: 'header border-bottom',
		minWidth: 70,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'changes',
		headerName: 'Cambios ejecutados',
		headerClassName: 'header border-bottom',
		renderCell: (params) => {
			return <ChangesField monthsData={params.value} />;
		},
		valueGetter: (_value, row) => {
			return row?.years_month?.[0]?.months;
		},
		minWidth: 450,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'hdate',
		headerName: 'Fecha de modificación',
		headerClassName: 'header border-bottom',
		minWidth: 70,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
		valueFormatter: (value) => {
			if (value == null) {
				return '';
			}
			return formatDate(value);
		},
	},
	{
		field: 'motivo',
		headerName: 'Motivo',
		headerClassName: 'header border-bottom',
		minWidth: 70,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
];

export const getRowId = (row) => row?.id;
export const rowsPerPageOptions = [5, 10, 25];

export const getDetailPanelHeight = () => 'auto';
export const getRowHeight = () => 100;

export const gridStyles = {
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid #E0E0E0',
	},

	'& .border-right': {
		borderRight: '1px solid #E0E0E0',
	},
	'& .border-bottom': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .MuiDataGrid-columnHeader--emptyGroup': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .header': {
		backgroundColor: '#f5f5f5',
	},
	'& .MuiDataGrid-filler': {
		height: 'fit-content !important',
	},
	'& .MuiDataGrid-main': {
		paddingBottom: '16px !important',
	},
	'& .MuiToolbar-root': {
		padding: '0 !important',
	},
	'& .MuiDataGrid-row:hover': {
		backgroundColor: 'transparent !important',
	},

	height: 'calc(100vh - 260px)',
};
